import {
  IncrementCurrentStep,
  DecrementCurrentStep,
  SetTotalSteps,
  SetFileToUpload,
  SetShowUploadPopup,
  SetCurrentStep,
  SetUploadProgress,
  SetUploadStep,
  ResetWizzard,
  SetWizzardError,
  SetReimportStarted,
  SetShowImportSlides,
  SetLoadingSlides,
  PushSlides,
  ClearSlides,
} from '@/constants/mutations';
import { GetAdditionalStepInfo, GetUploadProgress, GetZipFile } from '@/constants/getters.js';
import { ClearUploadFile, StartFileUpload, ResetUploadStep } from '@/constants/actions.js';
import { DEFAULT_WIZZARD_FILE, DEFAULT_UPLOAD_STEP, DEFAULT_WIZZARD_ERROR } from '@/constants/amp.js';

const defaultState = () => {
  return {
    stepInfo: '',
    currentStep: 1,
    totalSteps: 2,
    uploadProgress: 0,
    showUploadPopup: false,
    showImportSlides: false,
    loadingSlides: false,
    reimportStarted: false,
    slides: [],
    uploadStep: DEFAULT_UPLOAD_STEP,
    fileToUpload: DEFAULT_WIZZARD_FILE,
    wizzardError: DEFAULT_WIZZARD_ERROR,
  };
};

export const state = defaultState;

export const mutations = {
  [SetTotalSteps](state, steps) {
    state.totalSteps = steps;
  },

  [IncrementCurrentStep](state) {
    state.currentStep++;
  },

  [DecrementCurrentStep](state) {
    state.currentStep--;
  },

  [SetFileToUpload](state, data) {
    state.fileToUpload = data;
  },

  [SetShowUploadPopup](state, value) {
    state.showUploadPopup = value;
  },

  [SetCurrentStep](state, value) {
    state.currentStep = value;
  },

  [SetUploadProgress](state, value) {
    state.uploadProgress = value;
  },

  [ResetWizzard](state) {
    Object.assign(state, defaultState());
  },

  [SetUploadStep](state, value) {
    state.uploadStep = value;
  },

  [SetWizzardError](state, value) {
    state.wizzardError = value;
  },

  [SetReimportStarted](state, value) {
    state.reimportStarted = value;
  },

  [SetShowImportSlides](state, value) {
    state.showImportSlides = value;
  },

  [PushSlides](state, slides) {
    state.slides = [...state.slides, ...slides];
  },

  [ClearSlides](state) {
    state.slides = [];
  },

  [SetLoadingSlides](state, value) {
    state.loadingSlides = value;
  },
};

export const actions = {
  [ClearUploadFile]({ commit }) {
    commit(SetFileToUpload, DEFAULT_WIZZARD_FILE);
  },

  [StartFileUpload]({ commit }, file) {
    commit(SetFileToUpload, file);
    commit(SetShowUploadPopup, true);
  },

  [ResetUploadStep]({ commit }) {
    commit(SetFileToUpload, DEFAULT_WIZZARD_FILE);
  },
};

export const getters = {
  [GetAdditionalStepInfo](state, _getters, rootState) {
    if (state.currentStep === 1) return 'ampTypePreview';
    if (state.currentStep === 2) return 'ampPreview';

    if (state.currentStep === 3) {
      if (rootState.ampStore.createAmpDto.ampType === 'edetailer') {
        return 'uploadInfo';
      }
    }

    return null;
  },
  [GetZipFile](state) {
    if (['application/x-zip-compressed', 'application/zip'].includes(state.fileToUpload.type)) {
      return state.fileToUpload;
    }
  },
  [GetUploadProgress](state) {
    return (100 / state.uploadStep.steps) * state.uploadStep.stepIndex;
  },
};
